import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      '& > div': {
        marginTop: theme.spacing(1.5),

        display: 'flex',
        gap: '1rem',

        '& > .MuiFormControl-root': {
          margin: 0,
          '& .MuiOutlinedInput-input': {
            padding: theme.spacing(1.9, 1.8),
          },
        },

        '& > .MuiButtonBase-root': {
          width: 'max-content',
          margin: 0,
          height: 'min-content',
        },
      },
    },
    content: {
      paddingTop: 0,

      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1.5),

      '& > .MuiBox-root': {
        display: 'grid',
        alignItems: 'center',
        gridTemplateColumns: '1fr 1.4fr auto',

        backgroundColor: theme.palette.background.default,
        borderRadius: '0.5rem',
        padding: theme.spacing(1.2, 1.5),

        '& > *:nth-child(2)': {
          textAlign: 'center',
        },
      },
    },
    actions: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: 0,

      '& > .MuiButtonBase-root': {
        marginTop: 0,
        width: '13rem',
      },
    },
    inputLabel: {
      transform: 'translate(1.4rem, 1.6rem) scale(1)',
    },
  }),
)
